module.exports = __webpack_public_path__ + "static/media/features-quick-color.031a0a57.png";